<template>
    <el-tree
        v-bind="$attrs"
        v-on="$listeners"
        id="Tree"
        ref="tree"
        :data="treedata"
        :props="defaultProps"
        :render-content="renderContent"
        :node-key="nodeKey"
        :default-expanded-keys="defaultExpandedkeys"
        :default-checked-keys="defaultCheckedKeys"
        :expand-on-click-node="expandNode"
        highlight-current
        class="ztree z-tree-support"
        @node-click="nodeClick"
        @check-change="getSelectNode"
        :show-checkbox="showCheckbox"
        :current-node-key="currentKey"
        :accordion="accordion"
        :filter-node-method="filterNode"
    >
        <!--  -->
    </el-tree>
</template>
<script>
export default {
  name: 'tree',
  props: {
    treedata: {
      type: Array,
      default: function () {
        return this.$store.state.SchemaTree
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    nodeKey: {
      type: String,
      default: 'scene_code'
    },
    checkedKeys: {
      type: Array,
      default: () => []
    },
    expandedKeys: {
      type: Array,
      default: () => []
    },
    // 是否重置滚动条
    resetScroll: {
      type: Boolean,
      default: false
    },
    // 是否开启筛选
    showFilter: {
      type: Boolean,
      default: false
    },
    // 是否需要父级id
    hasParent: {
      type: Boolean,
      default: false
    },
    expandedkeys: {
      type: String,
      default: ''
    },
    accordion: {
      type: Boolean,
      default: false
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          children: 'item'
        }
      }
    },
    // 树默认选中的ID
    defaultChecked: {
      type: String
    },
    // date:2022 03 03
    expandNode: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    defaultChecked (newVal) {
      const nodeDatas = this.$refs.tree.store.nodesMap
      // 循环所有节点，将需要收起的节点数据的 expanded 属性设置为false
      for (const key in nodeDatas) {
        nodeDatas[key].expanded = false
      }
      this.$nextTick(() => {
        this.defaultExpandedkeys = [newVal]
        this.$refs.tree.setCurrentKey(newVal)
      })
    },
    treedata: {
      // tip 其实这里不需要通过传递值的 因为每次都是从vuex里面拿去然后传递过来 何不直接从这里直接拿到vuex的呢 也可能是数据的不统一性吧   不过之前的人写了 那就这样吧
      handler (newVal) {
        // date 2022 03 15 brian 设置默认
        if (newVal.length > 0) {
          this.$nextTick(() => {
            // 根据 nodeKey 动态取字段，避免 scene_code 重复时触发 Vue 重复 key 警告
            const id = this.defaultChecked || newVal[0][this.nodeKey]

            // 默认展开
            this.defaultCheckedKeys = this.defaultExpandedkeys = [id]
            // 默认选中
            this.currentKey = id
            this.$refs.tree.setCurrentKey(id)
          })
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      maxHeight: 500,
      // currentKey: '',
      defaultExpandedkeys: [],
      defaultCheckedKeys: [],
      currentKey: ''
    }
  },
  methods: {
    nodeClick (label, row, children, e) {
      this.$emit('changeNode', { label: label, row: row, children: children })
    },
    getSelectNode () {
      this.$emit('selectNode', { nodeArray: this.$refs.tree.getCheckedNodes() })
    },
    iconFn (data) {
      if (data.level === 0) return 'iconfont icon-kehu'
      // nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图）
      else if (data.nodeType === 2) {
        switch (data.funcType) {
          case 0: {
            return 'iconfont icon-zuzhijiagou'
          }
          case 1: {
            return 'el-icon-picture'
          }
          case 2: {
            return 'iconfont icon-ditu'
          }
          case 3: {
            return 'el-icon-menu';
          }
          default:
            break
        }
        // 监测点
      } else if (data.nodeType === 1) {
        return 'el-icon-wallet'
      }
    },
    // 树形控件的图标
    renderContent (h, { node, data, store }) {
      return (
        <div class="custom-tree-node" style="width:100%;padding-right:15px">
          <i class={this.iconFn(data)}></i>
          <span style="margin-left:5px">{node.label}</span>
        </div>
      )
      // var createElement = arguments[0]
      // let nodedata = arguments[1].node.data
      // if (nodedata.id == 'all' || nodedata.id == '0-0') {
      //   //全部
      //   return createElement('span', [
      //     createElement('i', {
      //       attrs: { class: 'iconfont icon-homepage' },
      //       style: {
      //         with: '14px',
      //         height: '20px',
      //         display: 'inline-block',
      //         margin: '0 5px',
      //       },
      //     }),
      //     createElement('span', '     '),
      //     createElement('span', arguments[1].node.label),
      //   ])
      // }
      // if (nodedata.level === 0) {
      //   //等于0说明范围  因为接口没有设置
      //   return createElement('span', [
      //     createElement('i', {
      //       attrs: { class: 'iconfont icon-homepage' },
      //       style: {
      //         with: '14px',
      //         height: '20px',
      //         display: 'inline-block',
      //         margin: '0 5px',
      //       },
      //     }),
      //     createElement('span', '     '),
      //     createElement('span', arguments[1].node.label),
      //   ])
      // } else if (nodedata.nodeType === 2) {
      //   //2 0什么都不关联则为单元 1==平面图 2==地图
      //   if (nodedata.funcType === 0) {
      //     return createElement('span', [
      //       createElement('i', {
      //         attrs: { class: 'iconfont icon-zhunbeiliangchan' },
      //         style: {
      //           with: '14px',
      //           height: '20px',
      //           display: 'inline-block',
      //           margin: '0 5px',
      //         },
      //       }),
      //       createElement('span', '     '),
      //       createElement('span', arguments[1].node.label),
      //     ])
      //   } else if (nodedata.funcType === 1) {
      //     return createElement('span', [
      //       createElement('i', {
      //         attrs: { class: 'iconfont icon-quyu' },
      //         style: {
      //           with: '14px',
      //           height: '20px',
      //           display: 'inline-block',
      //           margin: '0 5px',
      //         },
      //       }),
      //       createElement('span', '     '),
      //       createElement('span', arguments[1].node.label),
      //     ])
      //   } else if (nodedata.funcType === 2) {
      //     return createElement('span', [
      //       createElement('i', {
      //         attrs: { class: 'iconfont icon-ditu' },
      //         style: {
      //           with: '14px',
      //           height: '20px',
      //           display: 'inline-block',
      //           margin: '0 5px',
      //         },
      //       }),
      //       createElement('span', '     '),
      //       createElement('span', arguments[1].node.label),
      //     ])
      //   } else {
      //     return createElement('span', [
      //       createElement('i', {
      //         attrs: { class: 'iconfont icon-zhunbeiliangchan' },
      //         style: {
      //           with: '14px',
      //           height: '20px',
      //           display: 'inline-block',
      //           margin: '0 5px',
      //         },
      //       }),
      //       createElement('span', '     '),
      //       createElement('span', arguments[1].node.label),
      //     ])
      //   }
      // } else if (nodedata.nodeType === 1) {
      //   return createElement('span', [
      //     createElement('i', {
      //       attrs: { class: 'iconfont icon-shebeishuliang' },
      //       style: {
      //         with: '14px',
      //         height: '20px',
      //         display: 'inline-block',
      //         margin: '0 5px',
      //       },
      //     }),
      //     createElement('span', '     '),
      //     createElement('span', arguments[1].node.label),
      //   ])
      // } else if (nodedata.level === 1) {
      //   return createElement('span', [
      //     createElement('i', {
      //       attrs: { class: 'iconfont icon-homepage' },
      //       style: {
      //         with: '14px',
      //         height: '20px',
      //         display: 'inline-block',
      //         margin: '0 5px',
      //       },
      //     }),
      //     createElement('span', '     '),
      //     createElement('span', arguments[1].node.label),
      //   ])
      // } else {
      //   return createElement('span', [
      //     createElement('i', {
      //       attrs: { class: arguments[1].node.data.icon },
      //       style: {
      //         with: '14px',
      //         height: '20px',
      //         display: 'inline-block',
      //         margin: '0 5px',
      //       },
      //     }),
      //     createElement('span', '     '),
      //     createElement('span', arguments[1].node.data.name),
      //   ])
      // }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/tree.scss';

::v-deep.is-current {
    .el-tree-node__content span i {
        color: #fff;
    }

    .el-tree-node__children span i {
        color: var(--primary-color);
    }
}

.z-tree-support {
    padding: 2px;
    border: 0px;
}

// .ztree .el-tree-node:focus > .el-tree-node__content {
//   background-color: #fff !important;
// }
</style>
